import { ChainId } from '@pancakeswap/chains'
import { Address } from 'viem'
import { FarmV3SupportedChainId } from '../../src'
import { ComputedFarmConfigV3 } from '../../src/types'
import { farmsV3 as bscFarms } from '../bsc'

export const farmsV3ConfigChainMap: Record<FarmV3SupportedChainId, ComputedFarmConfigV3[]> = {
  [ChainId.PULSECHAIN]: bscFarms,
}

export type Addresses = {
  [chainId in ChainId]?: Address
}

export const bCakeFarmBoosterV3Address: Addresses = {
  [ChainId.PULSECHAIN]: '0x695170faE243147b3bEB4C43AA8DE5DcD9202752',
  // [ChainId.PULSECHAIN]: '0x56666300A1E25624489b661f3C6c456c159a109a',
}
export const bCakeFarmBoosterVeCakeAddress: Addresses = {
  [ChainId.PULSECHAIN]: '0x625F45234D6335859a8b940960067E89476300c6',
  // [ChainId.PULSECHAIN]: '0x1F32591CC45f00BaE3A742Bf2bCAdAe59DbAd228',
}
